import { __spreadArray } from "tslib";
import { SerialiseType, RelationType, DataType } from './Misc';
import NumberUtils from "../NumberUtils";
var PropertyInfo = /** @class */ (function () {
    function PropertyInfo(propertyName) {
        this.propertyName = propertyName;
        this.attributeRules = [];
        /** Name to use on labels for this property */
        this.displayName = "";
        /** True if the property does not cause the object to become dirty. */
        this.noTrack = false;
        /**
         * False if this is must not be converted to an observable.
         * True when defining observables on types that don't extend ModelBase.
         */
        this.isObservable = null;
        /** See SerialiseType */
        this.serialise = SerialiseType.Always;
        /** Type of parent / child if this property is related to another model. 'type' property must be set if this is not 'none'. */
        this.relationType = RelationType.None;
        /** Data type of the property. */
        this.propertyType = DataType.String;
        /**
         * Set if you want this value to be debounced when calling toQueryObjectAuto, or using the AutoRunner service.
         * By default, strings or properties decorated with integer or float are debounced.
         */
        this.debounce = null;
        /** True if this is a Vue / Mobx computed property. All getters become computed by default. */
        this.isComputed = null;
        /** List of rules that display on this property. */
        this.rules = [];
        /** Indicates that this property must be assigned to on de/serialisation. The de/serialiser will not try create a model instance of the object / array. */
        this.assignOnDeserialise = false;
    }
    Object.defineProperty(PropertyInfo.prototype, "readableName", {
        /** Gets the readable name of the property. Uses string.readable if Display decorator was not specified. */
        get: function () {
            if (!this._readableName) {
                if (this.displayName) {
                    this._readableName = this.displayName;
                }
                else {
                    this._readableName = this.propertyName.readable();
                }
            }
            return this._readableName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyInfo.prototype, "parent", {
        /**
         * Property info with the same property name from the parent class.
         */
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    PropertyInfo.prototype.addAttributeRule = function (rule) {
        this.rules.push(rule);
        this.attributeRules.push(rule);
    };
    PropertyInfo.prototype.clone = function () {
        var _a;
        var clone = new PropertyInfo(this.propertyName);
        for (var _i = 0, _b = Object.getOwnPropertyNames(this); _i < _b.length; _i++) {
            var propertyKey = _b[_i];
            // @ts-ignore
            clone[propertyKey] = this[propertyKey];
        }
        (_a = clone.rules).splice.apply(_a, __spreadArray([0, clone.rules.length], clone.attributeRules, false));
        clone._parent = this;
        return clone;
    };
    PropertyInfo.prototype.setPropertyType = function (propertyType) {
        if (!propertyType.prototype || !propertyType.prototype.constructor.name) {
            this.typeCallback = propertyType;
        }
        else {
            this._type = propertyType;
        }
    };
    Object.defineProperty(PropertyInfo.prototype, "type", {
        /**
         * Gets the constructor function of the return type.
         * Returns null if the property has not been decorated with a ChildObject / Parent attribute.
         */
        get: function () {
            if (this.typeCallback !== undefined) {
                return this.typeCallback();
            }
            else if (this._type) {
                return this._type;
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyInfo.prototype, "typeWithAssert", {
        /**
         * Gets the constructor function of the return type.
         * Raises an error if the property has not been decorated with a ChildObject / Parent attribute.
         */
        get: function () {
            var type = this.type;
            if (!type) {
                throw "".concat(this.propertyName, " has no property type defined. Make sure it is decorated with @Attributes.ChildObject.");
            }
            return type;
        },
        enumerable: false,
        configurable: true
    });
    PropertyInfo.prototype.createValueInstance = function () {
        try {
            return new this.typeWithAssert();
        }
        catch (error) {
            throw "Cannot create instance of property ".concat(this.propertyName, ": ").concat(error);
        }
    };
    PropertyInfo.prototype.setupFromInstance = function (instance) {
        var value = instance[this.propertyName];
        if (value) {
            if (NumberUtils.decimalService.isDecimal(value)) {
                this.propertyType = DataType.Decimal;
            }
        }
    };
    return PropertyInfo;
}());
export default PropertyInfo;
